import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../shared/services/auth.service';
import { TranslatePipe } from '../shared/i18n/translate.pipe';

/**
 * Strona z linku w mailu rejestracyjnym: aktywacja konta.
 *
 * Backend odpowiada `true` po udanej aktywacji, kopertą E 005 dla linku już
 * zużytego (komunikat pokazuje interceptor) i pustą odpowiedzią dla klucza,
 * którego nie ma - dwa ostatnie przypadki wyglądają tu tak samo, stąd jeden
 * stan „failed” z tekstem, który obejmuje obie możliwości.
 */
@Component({
    selector: 'app-accountconfirmation',
    templateUrl: './account-confirmation.component.html',
    styleUrls: ['./account-confirmation.component.css'],
    standalone: true,
    imports: [TranslatePipe, MatButtonModule, MatIconModule, RouterLink]
})
export class AccountConfirmationComponent implements OnInit {

  state: 'working' | 'confirmed' | 'failed' = 'working';

  constructor(private activatedRoute: ActivatedRoute, private authService: AuthService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      const key = params['confirmationCode'] ?? '';
      if (!key) {
        this.state = 'failed';
        return;
      }
      this.state = 'working';
      this.authService.signupConfirmation(key).subscribe({
        next: (data) => this.state = data === true ? 'confirmed' : 'failed',
        error: () => this.state = 'failed'
      });
    });
  }
}
